export default "__VITE_ASSET__ByoziO5Y__"